import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SectionTemplateComponent } from '@templates/section-template/section-template.component';
import { PublicationCardComponent } from './components/publication-card/publication-card.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { IHome_LatestPublicationResponse } from '@shared/constants/models.const';
import { E_FOLDER_TYPES } from '@shared/constants/enums.const';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../../services/helper.service';
import { SeeAllComponent } from '@shared/components/see-all/see-all.component';

@Component({
  selector: 'app-latest-publications-section',
  imports: [
    SectionTemplateComponent,
    PublicationCardComponent,
    TranslateModule,
    SeeAllComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './latest-publications-section.component.html',
  styleUrl: './latest-publications-section.component.scss',
})
export class LatestPublicationsSectionComponent {
  data = input.required<IHome_LatestPublicationResponse[]>();
  protected readonly ButtonTypes = BUTTON_TYPES;

  protected readonly E_FOLDER_TYPES = E_FOLDER_TYPES;

  navigate(): void {
    this.HELPER.seeAll(E_FOLDER_TYPES.Publication);
  }

  constructor(
    public HELPER: HelperService,
  ) {
  }
}
